import * as types from '../actions/action-types'

export const newsSearchParams = (state={query: ''}, action) => {
	switch (action.type) {
		case types.SEARCH_NEWS_CHANGE_QUERY_REQUEST:
			return Object.assign({},state, {query: action.payload})
        default:
        return state
    }
}